jQuery(document).ready(function($) {
    $('.mobile-menu > .menu-item-has-children > a').click(function(e) {
        e.preventDefault(); // Voorkom de standaard link actie

        var submenu = $(this).siblings('.sub-menu');

        // Als het submenu zichtbaar is, volg de link
        if (submenu.is(':visible')) {
            window.location.href = $(this).attr('href');
        } else {
            // Toggle het submenu
            submenu.slideToggle();

            // Sluit andere submenu's (optioneel)
            $('.sub-menu').not(submenu).slideUp();
        }
    });

    // Show or hide the button based on scroll position
    $(window).scroll(function() {
        if ($(this).scrollTop() > 200) {
            $('#back-to-top').fadeIn();
        } else {
            $('#back-to-top').fadeOut();
        }
    });

    // Smooth scroll back to top
    $('#back-to-top').click(function(event) {
        event.preventDefault(); // Prevent default anchor behavior
        $('html, body').animate({scrollTop: 0}, 800); // 800 is the scroll duration in ms
    });

    $('.editor img').each(function () {
        $(this).parent().addClass('editor__image');
        if ($(this).hasClass('aligncenter')) {
            $(this).parent().addClass('editor__image--align-center');
        } else if ($(this).hasClass('alignright')) {
            $(this).parent().addClass('editor__image--align-right');
        }
    });

    $('.read-more__link').on('click', function (e) {
        e.preventDefault();
        $(this).parent().parent().find('.read-more__content').slideToggle();
    });

    //filter option search
  function updateVisibility() {
    $('.col-md-6.paginas').toggle($('#filter-paginas').is(':checked'));
    $('.col-md-6.producten').toggle($('#filter-producten').is(':checked'));
  }

  // Event listeners
  $('#filter-paginas, #filter-producten').on('change', updateVisibility);

  // Initial call
  updateVisibility();



});